import "./TagFilter.css";

import { SelectData } from "../../../models";
import { MultiSelect } from "../MultiSelect";

export interface TagFilterProps {
  // The available tags to filter by ({ key: tagUuid, value: tagName }).
  tags: SelectData;
  // Currently selected tag keys.
  values: string[];
  onChange: (keys: string[]) => void;
  placeholder?: string;
  label?: string;
  className?: string;
  disabled?: boolean;
  corners?: "rounded" | "default";
}

/*
  Reusable tag multi-select filter (a thin, tag-specific wrapper around MultiSelect) intended to sit
  inline in a page/toolbar header. Presentational — the caller supplies the tag options and owns the
  selection, so it can be fed from any tag source and mocked directly in Storybook.
*/
export const TagFilter = ({
  tags,
  values,
  onChange,
  placeholder = "Tags",
  label = " ",
  className,
  disabled = false,
  corners = "rounded",
}: TagFilterProps): JSX.Element => (
  <MultiSelect
    label={label}
    className={`TagFilter ${className ?? ""}`}
    placeholder={placeholder}
    data={tags}
    values={values}
    onChange={onChange}
    corners={corners}
    disabled={disabled}
  />
);
